import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-booking-status',
  templateUrl: './booking-status.component.html',
  styleUrls: ['./booking-status.component.scss']
})
export class BookingStatusComponent implements OnInit {

  isSuccess: string = "";
  payment_details_storage: any;
  payment_response: any;
  appointmentDate: any;

  // private headerHeight = 10;
  @ViewChild('navbar') navbar: ElementRef | undefined;
  @ViewChild('bannerContainer') bannerContainer: ElementRef | undefined;

  constructor(private route: ActivatedRoute,  private storage: StorageService, private datePipe: DatePipe, private router: Router,) {

  }
  // Current date function
  currentDate: Date = new Date();

  extractStartDate() {

      // Check if payment_details_storage and slot_time are defined
    if (this.payment_details_storage && this.payment_details_storage.slot_time) {
      // Split the response to get the first date (start date)
      const formattedDateString = this.payment_details_storage.slot_time.split(' ')[0]; // "2024-09-19"
      
      // Convert the string into a Date object
      this.appointmentDate = new Date(formattedDateString);
  } else {
      console.error('slot_time is undefined or payment_details_storage is not properly set:', this.payment_details_storage);
      this.appointmentDate = null; // Or handle as needed
  }


    // // Split the response to get the first date (start date)
    // const formattedDateString = this.payment_details_storage.slot_time.split(' ')[0]; // "2024-09-19 15:00:00"
    
    // // Convert the string into a Date object
    // this.appointmentDate = new Date(formattedDateString);
  }
  ngAfterViewInit(): void {
    // Handle smooth scrolling to the fragment after the page is loaded
    this.route.fragment.subscribe(fragment => {
      if (fragment) {
        const element = document.getElementById(fragment);
        if (element) {
          // Dynamically calculate the height of navbar and banner container
          const navbarHeight = this.navbar?.nativeElement.offsetHeight || 0;
          const bannerHeight = this.bannerContainer?.nativeElement.offsetHeight || 0;

          // Adjust the scroll position based on the navbar and banner height
          const totalOffset = navbarHeight + bannerHeight;

          // Scroll to the element considering the header and banner heights
          setTimeout(() => {
            window.scrollTo({
              top: element.offsetTop - totalOffset, // Subtract the combined heights
              behavior: 'smooth'
            });
          }, 100); // Small delay to ensure DOM is ready
        }
      }
    });
  }

  ngOnInit(): void {
    // Obtaining booking payment details data from storage
    this.payment_details_storage = JSON.parse(this.storage.get('booking_details') || '{}');
    this.payment_response = JSON.parse(this.storage.get('booking_response') || '{}');

    // The dedicated AI booking page stores the patient form in its prefill
    // record before handing off to the secure booking/payment flow.
    if (!this.payment_details_storage?.name) {
      const aiPrefill = JSON.parse(this.storage.get('ai-booking-prefill') || '{}');
      const patientName = aiPrefill?.patient?.name;
      if (patientName) {
        this.payment_details_storage = {
          ...this.payment_details_storage,
          name: patientName
        };
      }
    }

    console.log('The payment storage details is', this.payment_details_storage);
    console.log("The payment response details is", this.payment_response);

    this.extractStartDate();

    this.route.params.subscribe(params => {
      this.isSuccess = params['isSuccess'];
      console.log("The value of isSuccess", this.isSuccess);
    });

    // if url manually updated then redirect to home page
    if (!this.payment_response || Object.keys(this.payment_response).length === 0) {
      this.router.navigate(['']);
    }

  }

  // Redirect if page is success
  successRedirect() {
    this.router.navigate(['/form']);
  }


  // Redirect if page is failed
  failedRedirect() {
    this.router.navigate(['']);
  }
}


